'use client';

import Grid from '@/components/Grid';
import Section from '@/components/Section';
import ShowTile from '@/components/ShowTile';
import ButtonLink from '@/components/atoms/ButtonLink';
import type { Event_Entry } from '@/types/graphql';
import { useTranslations } from 'next-intl';

interface WhatsOnEventsProps {
    events: Event_Entry[];
    locale: string;
}

export default function WhatsOnEvents({ events, locale }: WhatsOnEventsProps) {
    const t = useTranslations('WhatsOnEvents');

    return (
        <>
            <Section title="Shows" variant="collection">
                <Grid>
                    {events.map((event) => (
                        <ShowTile
                            key={event.id}
                            event={event}
                            priority={false}
                            className={'event-tile'}
                            locale={locale}
                        />
                    ))}
                </Grid>
            </Section>

            <div className="mr-2 mb-8 ml-2 sm:ml-12 md:mr-4 md:ml-16 lg:mr-8 lg:ml-28">
                <ButtonLink href="/shows" variant="active">
                    {t('show-all-shows')}
                </ButtonLink>
            </div>
        </>
    );
}
